<template>
  <div class="body_box">
    <el-button :disabled="getPdfStatus" style="position: absolute;right: 0px;top: -42px;border:outset;" @click="getPdf()">导出PDF</el-button>
    <div id="pdfDom" class="box_all">
      <div class="box_top">
        <div class="top_title">重点单位消防设施物联网系统远程监控安装要求检测</div>
        <h1 class="top_report">消防物联网接入质量报告</h1>
        <div v-if="prod === 'hp' || prod === 'hpnw' " style="padding:30px 0;font-size: 20px;font-weight: bold;text-align:center;color:#000;">黄浦区消防大数据中心</div>
        <div v-else style="padding:30px 0;font-size: 20px;font-weight: bold;text-align:center;color:#000;">静安消防蓝盾网</div>
        <div class="top_bianhao">No.{{ buildingData.report_code }}</div>
        <div class="top_detail">
          <div class="top_detail_title">受检项目：{{ buildingData.building_name }}</div>
          <div class="top_detail_zhiliang">
            <span style="flex: 3">质量判断：</span>
            <span style="flex: 7;">
              <div>备案完整度</div>
              <div>接入达标率</div>
              <div>数据化消防运维长效性</div>
            </span>
          </div>
          <div class="top_detail_title">判断结果：<span :style="{color: buildingData.report_status === 3 ? '#29CC5F' : '#CC4429'}" style="font-weight: bold;">{{ queryReportStatus(buildingData.report_status) }} </span></div>
          <div v-if="buildingData.report_status === 1" class="top_detail_title">持续时间：{{ DateDifference(buildingData.report_start_time, new Date()) }}</div>
          <div v-else-if="buildingData.report_status === 2" class="top_detail_title">持续时间：{{ DateDifference(buildingData.report_end_time, new Date()) }}</div>
          <div class="top_detail_title">截止时间：{{ buildingData.now_time }}</div>
        </div>
      </div>
      <div style="text-align:center;">（注：由于数据时刻变化，此报告中的数据是截止当前时间之前的数据）</div>
      <span style="display: block;border-bottom: 1px dashed #888888;margin:75px 0;">{{ null }}</span>
      <div style="padding-bottom:50px;">
        <div class="box_jieru">
          <h2 class="box_title">一、项目基本信息</h2>
          <!-- 地址信息 -->
          <h3 style="padding: 10px 0;">地址信息</h3>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
            <tr>
              <td class="table_one">基本信息</td>
              <td>明细</td>
            </tr>
            <tr v-for="(item, index) in buildingData.buildingAddress" :key="index">
              <td v-if="index === 0" :rowspan="buildingData.buildingAddress.length">项目地址</td>
              <td>{{ item.address }}</td>
            </tr>
            <tr v-if="!beianReport.address">
              <td>项目地址</td>
              <td style="color:#CC4429">未备案</td>
            </tr>
          </table>
          <!-- 消防人员信息 -->
          <h3 style="padding: 10px 0;">消防人员信息</h3>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
            <tr>
              <td class="table_one">基本信息</td>
              <td>明细</td>
            </tr>
            <tr v-for="(item, index) in buildingData.employeeList" :key="index">
              <td v-if="index === 0" :rowspan="buildingData.employeeList.length">消防安全责任人</td>
              <td>{{ item.name }}&emsp;&emsp;{{ item.mobile }}</td>
            </tr>
            <tr v-if="!buildingData.employeeList.length">
              <td>消防安全责任人</td>
              <td style="color:#CC4429">未备案</td>
            </tr>
            <tr v-for="(item, index) in buildingData.ctrlroom_phone" :key="index">
              <td v-if="index === 0" :rowspan="buildingData.ctrlroom_phone.length">消控室联系电话</td>
              <td>{{ item || '未备案' }}</td>
            </tr>
            <tr v-if="!buildingData.ctrlroom_phone.length">
              <td>消控室联系电话</td>
              <td style="color:#CC4429">未备案</td>
            </tr>
          </table>
          <!-- 消防重点部位信息 -->
          <h3 style="padding: 10px 0;">消防重点部位信息</h3>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
            <tr>
              <td class="table_one">基本信息</td>
              <td>名称</td>
              <td>位置</td>
              <td style="width:200px;">备注</td>
              <td>是否有图</td>
            </tr>
            <tr v-for="(item, index) in buildingData.keyPartList" :key="index">
              <td v-if="index === 0" :rowspan="buildingData.keyPartList.length">消防重点部位</td>
              <td>{{ item.name }}</td>
              <td>{{ item.b_name }}，{{ item.f_name }}</td>
              <td>{{ getRemark(item.danger_source) }}</td>
              <td :style="{color: item.image ? '#29CC5F' : '#CC4429'}">{{ item.image ? '是' : '否' }}</td>
            </tr>
            <tr v-if="!buildingData.keyPartList.length">
              <td>消防重点部位</td>
              <td style="color:#CC4429" colspan="4">未备案</td>
            </tr>
          </table>
        </div>
        <div class="box_jieru">
          <h2 class="box_title">二、备案完整度</h2>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
            <tr>
              <td class="table_one">备案内容</td>
              <td>明细</td>
              <td class="table_bottom">状态</td>
            </tr>
            <tr>
              <td rowspan="2">项目信息备案</td>
              <td>项目楼宇信息</td>
              <td :style="{color: beianReport.buildNum ? '#29CC5F' : '#CC4429'}">{{ beianReport.buildNum ? '已备案' : '未备案' }}</td>
            </tr>
            <tr>
              <td>每层楼的平面图</td>
              <td :style="{color: beianReport.planImages ? '#29CC5F' : '#CC4429'}">{{ beianReport.planImages ? '已备案' : '未备案' }}</td>
            </tr>
            <tr>
              <td rowspan="2">设施设备信息</td>
              <td>设备登记</td>
              <td :style="{color: beianReport.deviceEnter ? '#29CC5F' : '#CC4429'}">{{ beianReport.deviceEnter ? '已备案' : '未备案' }}</td>
            </tr>
            <tr>
              <td>点位导入</td>
              <td :style="{color: beianReport.pointImport ? '#29CC5F' : '#CC4429'}">{{ beianReport.pointImport ? '已备案' : '未备案' }}</td>
            </tr>
          </table>
        </div>
        <div class="box_jieru">
          <h2 class="box_title">三、接入达标率</h2>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
            <tr>
              <td class="table_one">系统名称</td>
              <td>设备名称</td>
              <td>备案数量</td>
              <td>已接入数量</td>
              <td class="table_bottom">状态</td>
            </tr>
            <tr v-for="(item, index) in deviceList" :key="index">
              <td v-if="objectSpanMethod(item, index, true)" :rowspan="objectSpanMethod(item, index, true)">{{ item.systemname }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.number }}</td>
              <td v-if="objectSpanMethod(item, index, false)" :rowspan="objectSpanMethod(item, index, false)">{{ item.pro_count }}</td>
              <td v-if="objectSpanMethod(item, index, false)" :rowspan="objectSpanMethod(item, index, false)" :style="{color: item.isPass ? '#29CC5F' : '#CC4429'}">{{ item.isPass ? '合格' : '不合格' }}</td>
            </tr>
          </table>
        </div>
        <div class="box_jieru">
          <h2 class="box_title">四、数据化消防运维长效性</h2>
          <table border="1" align="center" cellpadding="0" cellspacing="0" class="table_box">
            <tr>
              <td class="table_one">评估内容</td>
              <td>说明</td>
              <td class="table_bottom">状态</td>
            </tr>
            <tr>
              <td>是否响应过报警事件</td>
              <td>生成数量：{{ eventReport.eventData.createNum }}，响应数量：{{ eventReport.eventData.handlerNum }}</td>
              <td :style="{color: eventReport.eventData.isPass ? '#29CC5F' : '#CC4429'}">{{ eventReport.eventData.isPass ? '合格' : '不合格' }}</td>
            </tr>
            <tr>
              <td>是否响应过电子督察单</td>
              <td>生成数量：{{ eventReport.taskData.createNum }}，响应数量：{{ eventReport.taskData.handlerNum }}</td>
              <td :style="{color: eventReport.taskData.isPass ? '#29CC5F' : '#CC4429'}">{{ eventReport.taskData.isPass ? '合格' : '不合格' }}</td>
            </tr>
            <tr>
              <td>是否响应过人工督察单</td>
              <td>生成数量：{{ eventReport.sheetData.createNum }}，响应数量：{{ eventReport.sheetData.handlerNum }}</td>
              <td :style="{color: eventReport.sheetData.isPass ? '#29CC5F' : '#CC4429'}">{{ eventReport.sheetData.isPass ? '合格' : '不合格' }}</td>
            </tr>
            <tr>
              <td>报警事件生成人工督察单的占比超过{{ eventReport.sheetProportion.sysconfig }}%</td>
              <td>报警事件数量：{{ eventReport.eventData.createNum }}，生成人工督察单数量：{{ eventReport.sheetProportion.taskSheetNum }}，占比达{{ eventReport.sheetProportion.proportion }}%</td>
              <td :style="{color: eventReport.sheetProportion.isPass ? '#29CC5F' : '#CC4429'}">{{ eventReport.sheetProportion.isPass ? '合格' : '不合格' }}</td>
            </tr>
            <tr>
              <td>设备离线率超过{{ eventReport.deviceOffline.sysconfig }}%</td>
              <td>总设备数量：{{ eventReport.deviceOffline.deviceNum }}，离线中设备：{{ eventReport.deviceOffline.offlineNum }}，占比达{{ eventReport.deviceOffline.proportion }}%</td>
              <td :style="{color: eventReport.deviceOffline.isPass ? '#29CC5F' : '#CC4429'}">{{ eventReport.deviceOffline.isPass ? '合格' : '不合格' }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { buildingReport, getWordbook } from '@/api/gov'
export default {
  props: {
    pid: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      dangerSourceMap: {},
      prod: process.env.ENV_SERVER,
      htmlTitle: '接入质量报告',
      getPdfStatus: true,
      buildingData: {
        building_name: '',
        report_code: '',
        report_time: '',
        report_end_time: '',
        report_status: 0,
        ctrlroom_phone: '',
        employeeList: [],
        buildingAddress: [],
        keyPartList: []
      },
      beianReport: {
        address: 0,
        phone: 0,
        buildNum: 0,
        keyImages: 0,
        planImages: 0,
        deviceEnter: 0,
        pointImport: 0
      },
      eventReport: {
        eventData: {
          createNum: 0,
          handlerNum: 0,
          isPass: 0
        },
        taskData: {
          createNum: 0,
          handlerNum: 0,
          isPass: 0
        },
        sheetData: {
          createNum: 0,
          handlerNum: 0,
          isPass: 0
        },
        sheetProportion: {
          proportion: 0,
          taskSheetNum: 0,
          sysconfig: 0.01,
          isPass: 0
        },
        deviceOffline: {
          deviceNum: 0,
          offlineNum: 0,
          proportion: 0,
          sysconfig: 0.01,
          isPass: 0
        }
      },
      deviceList: []
    }
  },
  created () {
    this.getBuildingReport()
    this.wordbookList()
  },
  methods: {
    async getBuildingReport () {
      const obj = {
        pid: this.pid
      }
      const res = await buildingReport(obj)
      if (res.code === 0) {
        const reportData = res.data
        this.buildingData = reportData.buildingData
        this.beianReport = reportData.beianReport
        this.deviceList = reportData.deviceList
        this.eventReport = reportData.eventReport
      }
      this.$nextTick(() => {
        this.htmlTitle = this.buildingData.building_name + '-接入质量报告'
        this.getPdfStatus = false
      })
    },
    async wordbookList () {
      const res = await getWordbook({field: 'key_part_danger_source'})
      if (res.code === 0) {
        const map = {}
        for (const v of res.data) {
          map[v.val] = v.display
        }
        this.dangerSourceMap = map
      }
    },
    getRemark (value) {
      if (value) {
        var valueArr = value.split(',')
        var newArr = []
        for (const item of valueArr) {
          const name = this.dangerSourceMap[item]
          newArr.push(name)
        }
        return newArr.join('，')
      } else {
        return ''
      }
    },
    objectSpanMethod (row, rowIndex, type) {
      if (type || row.systemid === 42) {
        var num = 0
        for (var i = 0; i < this.deviceList.length; i++) {
          if (row.systemname === this.deviceList[i].systemname) {
            num++
          }
        }
        if (num === 1) {
          return num
        } else if (num > 1) {
          if (this.deviceList[rowIndex - 1] && this.deviceList[rowIndex].systemname === this.deviceList[rowIndex - 1].systemname) {
            return 0
          } else {
            return num
          }
        }
      } else {
        return 1
      }
    },
    queryReportStatus (value) {
      var status = '未接入'
      switch (value) {
        case 0:
          status = '未接入'
          break
        case 1:
          status = '待改进'
          break
        case 2:
          status = '缺陷中'
          break
        case 3:
          status = '已达标'
          break
      }
      return status
    },
    DateDifference (creattime, endtime) {
      var begin = new Date(creattime)
      var end = new Date(endtime)
      // 时间相差毫秒数
      var span = end.getTime() - begin.getTime()
      if (span > 0) {
        // 计算相差天数
        var result = ''
        var days = Math.floor(span / (24 * 3600 * 1000))
        if (days > 0) {
          result += days + '天'
        }
        // 相差小时数
        var leave1 = span % (24 * 3600 * 1000)
        var hours = (Array(2).join(0) + (Math.floor(leave1 / (3600 * 1000)))).slice(-2)
        if (hours > 0) {
          result += hours + '小时'
        }
        // 相差分钟
        var leave2 = leave1 % (3600 * 1000)
        var minutes = (Array(2).join(0) + (Math.floor(leave2 / (60 * 1000)))).slice(-2)
        if (!(days > 0)) {
          result += minutes + '分钟'
        }
        // 相差秒
        var level3 = leave2 % (60 * 1000)
        var seconds = (Array(2).join(0) + (Math.round(level3 / 1000))).slice(-2)
        if (!(days > 0) && !(hours > 0)) {
          result += seconds + '秒'
        }
        // var time = days + ':' + hours + ':' + minutes + ':' + result
        return result
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.body_box{
  width: 800px;
  position: relative;
  margin: 0 auto;
}
.box_all{
  width: 800px;
  margin-top: 50px;
  margin-bottom: 50px;
  border: 1px solid #000;
}
.top_title{
  text-align: center;
  padding-bottom: 20px;
  margin-top: 80px;
  font-size: 16px;
}
.top_report{
  text-align: center;
  letter-spacing:10px;
  padding-bottom: 10px;
  font-size: 2rem;
}
.top_bianhao{
  font-weight: bold;
  padding-bottom: 10px;
  text-align: center;
  padding-bottom: 30px;
  font-size: 16px;
}
.top_detail{
  width: 400px;
  margin: 0 auto;
}
.top_detail_title {
  font-size: 20px;
  font-weight: 500;
  padding: 10px 0;
}
.top_detail_zhiliang{
  display: flex;
  font-size: 20px;
  font-weight: 500;
  padding: 10px 0;
}
.table_box{
  width: 600px;
  text-align: center;
}
.table_box td{
  height: 50px;
}
.table_one{
  width: 250px;
}
.table_bottom{
  width: 100px;
}
.box_jieru{
  padding: 0 100px;
}
.box_title{
  padding-top: 60px;
  padding-bottom: 20px;
  font-size: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/basicComponents/buildingReport.vue